/**
 * Low Bandwidth Mode
 *
 * Persists user preference in localStorage and manages the low-bandwidth-mode
 * class on the <html> element to reduce data usage by hiding images.
 */

(function() {
  'use strict';

  const STORAGE_KEY = 'searhc_low_bandwidth';
  const COOKIE_NAME = 'searhc_low_bandwidth';
  const HTML_CLASS = 'low-bandwidth-mode';

  /**
   * Set a cookie (for PHP to read)
   */
  function setCookie(value) {
    const expires = value ? 'Fri, 31 Dec 9999 23:59:59 GMT' : 'Thu, 01 Jan 1970 00:00:00 GMT';
    document.cookie = COOKIE_NAME + '=' + (value ? '1' : '') + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  /**
   * Check if low bandwidth mode is enabled
   */
  function isEnabled() {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  }

  /**
   * Enable low bandwidth mode
   */
  function enable() {
    localStorage.setItem(STORAGE_KEY, 'true');
    setCookie(true);
    document.documentElement.classList.add(HTML_CLASS);
    syncToggle(true);
  }

  /**
   * Disable low bandwidth mode
   */
  function disable() {
    localStorage.setItem(STORAGE_KEY, 'false');
    setCookie(false);
    document.documentElement.classList.remove(HTML_CLASS);
    syncToggle(false);
  }

  /**
   * Sync toggle switch state with stored preference
   */
  function syncToggle(checked) {
    ['low-data-toggle', 'low-data-toggle-mobile'].forEach(function(id) {
      const toggle = document.getElementById(id);
      if (toggle) {
        toggle.checked = checked;
        toggle.setAttribute('aria-checked', checked);
      }
    });
  }

  /**
   * Initialize on page load
   */
  function init() {
    // Apply stored preference immediately
    if (isEnabled()) {
      document.documentElement.classList.add(HTML_CLASS);
      setCookie(true); // Ensure cookie stays in sync
    }

    // Wait for DOM to sync toggle state and bind events
    document.addEventListener('DOMContentLoaded', function() {
      syncToggle(isEnabled());

      // Listen for toggle changes (fires when toggleswitch component JS is loaded)
      document.addEventListener('toggle:changed', function(e) {
        if (e.detail && e.detail.name === 'low_data_mode') {
          if (e.detail.checked) {
            enable();
          } else {
            disable();
          }
        }
      });

      // Direct change listener on the toggle inputs — works even when
      // toggleswitch component JS is not loaded (low data mode)
      ['low-data-toggle', 'low-data-toggle-mobile'].forEach(function(id) {
        var toggle = document.getElementById(id);
        if (toggle) {
          toggle.addEventListener('change', function() {
            if (toggle.checked) {
              enable();
            } else {
              disable();
            }
          });
        }
      });
    });
  }

  // Run initialization
  init();

})();
